import { render, staticRenderFns } from "./SoilDetail.vue?vue&type=template&id=15b066e7&scoped=true&"
import script from "./SoilDetail.vue?vue&type=script&lang=js&"
export * from "./SoilDetail.vue?vue&type=script&lang=js&"
import style0 from "./SoilDetail.vue?vue&type=style&index=0&id=15b066e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b066e7",
  null
  
)

export default component.exports